exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DatapointAnalysisPage .DebounceInputFilter input, .DatapointAnalysisPage .SimpleTimeRangeFilter select{\n  width: 125px;\n}\n\n.DatapointAnalysisPage .DebounceInputFilter.filter:last-child {\n  margin-right: 0;\n}\n\n.DatapointAnalysisPage .SingleValueDisplayReport .displayValue{\n font-size: 36px;\n}", ""]);

// exports
